import React, { useState, ChangeEvent, useRef, useEffect } from 'react';

interface SplitSectionEditorProps {
  title: string;
  paragraph1: string;
  paragraph2: string;
  imageSrc: string;
  onSave: (newTitle: string, newParagraph1: string, newParagraph2: string, newImageSrc: string) => void;
}

const SplitSectionEditor: React.FC<SplitSectionEditorProps> = ({ title, paragraph1, paragraph2, imageSrc, onSave }) => {
  const [newTitle, setNewTitle] = useState(title);
  const [newParagraph1, setNewParagraph1] = useState(paragraph1);
  const [newParagraph2, setNewParagraph2] = useState(paragraph2);
  const [newImageSrc, setNewImageSrc] = useState(imageSrc);
  const [isAccordionOpen, setIsAccordionOpen] = useState(false);

  const iframeRef = useRef<HTMLIFrameElement>(null);

  useEffect(() => {
    if (iframeRef.current) {
      iframeRef.current.onload = () => {
        applyChangesToIframe();  // Aplicar los cambios cuando el iframe esté cargado
      };
    }
  }, [iframeRef]);

  const handleImageChange = async (event: ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    const backendUrl = process.env.REACT_APP_BACKEND_URL || 'http://localhost:3001';

    if (file) {
      const formData = new FormData();
      formData.append('landingImage', file);

      try {
        // Subir la imagen al servidor
        const response = await fetch(`${backendUrl}/upload-landing-image`, {
          method: 'POST',
          body: formData,
        });

        const data = await response.json();
        const imageUrl = data.landingImageUrl;

        setNewImageSrc(imageUrl); // Actualizar el estado de la nueva imagen

        // Aquí actualizamos el iframe con la nueva imagen
        const iframeDocument = iframeRef.current?.contentDocument;
        if (iframeDocument) {
          const splitImageElement = iframeDocument.getElementById('split-section-image');
          if (splitImageElement && splitImageElement instanceof HTMLImageElement) {
            splitImageElement.src = imageUrl; // Actualiza la imagen en el iframe
            console.log(`Imagen actualizada en el iframe con URL: ${imageUrl}`);
          } else {
            console.error('No se encontró el elemento split-section-image en el iframe.');
          }
        }

      } catch (error) {
        console.error('Error al subir la imagen:', error);
      }
    }
  };
  useEffect(() => {
    const iframeDocument = iframeRef.current?.contentDocument;
    if (iframeDocument) {
      const splitImageElement = iframeDocument.getElementById('split-section-image');
      if (splitImageElement && splitImageElement instanceof HTMLImageElement) {
        splitImageElement.src = newImageSrc;
      }
    }
  }, [newImageSrc]);
  

  const applyChangesToIframe = () => {
    const iframeDocument = iframeRef.current?.contentDocument;
    if (iframeDocument) {
      // Aquí realizas los cambios en el iframe. Por ejemplo:
      const titleElement = iframeDocument.getElementById('split-section-title');
      const paragraph1Element = iframeDocument.getElementById('split-section-paragraph1');
      const paragraph2Element = iframeDocument.getElementById('split-section-paragraph2');
      const imageElement = iframeDocument.getElementById('split-section-image');
      if (imageElement && imageElement instanceof HTMLImageElement) {
        console.log('Actualizando split-section-image:', newImageSrc); // Verifica la URL de la imagen
        imageElement.src = newImageSrc; // Aplica la URL de la imagen
      } else {
        console.error('No se encontró split-section-image en el iframe.');
      }
      if (titleElement) titleElement.textContent = newTitle;
      if (paragraph1Element) paragraph1Element.textContent = newParagraph1;
      if (paragraph2Element) paragraph2Element.textContent = newParagraph2;
      if (imageElement && imageElement instanceof HTMLImageElement) {
        imageElement.src = newImageSrc;
      }

    }
  };

  const handleSave = () => {
    onSave(newTitle, newParagraph1, newParagraph2, newImageSrc); // Llama a onSave con los nuevos valores
  };

  return (
    <div className="editor-accordion">
      <div className="accordion-item">
        <h3 onClick={() => setIsAccordionOpen(!isAccordionOpen)}>
          Editar Sección Dividida (Título, Texto, Imagen)
        </h3>

        {isAccordionOpen && (
          <div className="accordion-content">
            <label>
              Título:
              <input type="text" value={newTitle} onChange={(e) => setNewTitle(e.target.value)} />
            </label>

            <label>
              Primer Párrafo:
              <textarea value={newParagraph1} onChange={(e) => setNewParagraph1(e.target.value)} />
            </label>

            <label>
              Segundo Párrafo:
              <textarea value={newParagraph2} onChange={(e) => setNewParagraph2(e.target.value)} />
            </label>

            <label>
              Cambiar Imagen:
              <input type="file" onChange={handleImageChange} />
            </label>

            {newImageSrc && <img src={newImageSrc} alt="Preview" style={{ maxWidth: '100%' }} />}

            <button onClick={handleSave}>Guardar Cambios</button>
          </div>
        )}
      </div>
    </div>
  );
};

export default SplitSectionEditor;
